module.exports = __webpack_public_path__ + "img/my_icon_gray@2x.5c767ec7.png";